import { Controller } from "stimulus";

export default class OriginController extends Controller {
  static values = {
    page: Number,
    sort: String,
    threadId: Number,
  };

  store() {
    const origin = {
      page: this.hasPageValue ? this.pageValue : null,
      sort: this.hasSortValue ? this.sortValue || null : null,
      threadId: this.hasThreadIdValue ? this.threadIdValue : null,
    };

    try {
      window.sessionStorage.setItem(
        "subscriber_v2_threads_origin",
        JSON.stringify(origin),
      );
    } catch (e) {
      // Ignore storage failures
    }
  }
}
